// Umami analytics event tracking utility

export const trackEvent = (eventName, eventData = {}) => {
  if (window.umami) {
    window.umami.track(eventName, eventData);
  }
};

// Core events
export const trackSessionStart = (sessionId, cardCount) => {
  trackEvent("session_start", { sessionId, cardCount });
};

export const trackShowAnswer = (sessionId, cardIndex) => {
  trackEvent("show_answer", { sessionId, cardIndex });
};

export const trackNextCard = (sessionId, cardIndex) => {
  trackEvent("next_card", { sessionId, cardIndex });
};

export const trackPreviousCard = (sessionId, cardIndex) => {
  trackEvent("previous_card", { sessionId, cardIndex });
};

export const trackSessionComplete = (sessionId, totalCards) => {
  trackEvent("session_complete", { sessionId, totalCards });
};

// UI events
export const trackThemeToggle = (theme) => {
  trackEvent("theme_toggle", { theme });
};

export const trackQRCodeView = (sessionId) => {
  trackEvent("qr_code_view", { sessionId });
};

export const trackPrintCards = (sessionId, cardCount) => {
  trackEvent("print_cards", { sessionId, cardCount });
};

export const trackAppDownloadClick = (platform) => {
  trackEvent("app_download_click", { platform });
};

// Session control events
export const trackSessionRestart = (sessionId, cardCount) => {
  trackEvent("session_restart", { sessionId, cardCount });
};

export const trackSessionShuffle = (sessionId, cardCount) => {
  trackEvent("session_shuffle", { sessionId, cardCount });
};

// Keyboard interaction events
export const trackKeyboardShortcut = (sessionId, shortcutType) => {
  trackEvent("keyboard_shortcut", { sessionId, shortcutType });
};
